import type { BladeFile } from '@razorpay/blade/components';
import type { PolicySummaryItem } from 'components/Settings/EmployeeLoansSettings/types';

export type CreateLoanRequestFormData = {
  loanCategoryId: number | null;
  categoryName: string;
  isDocumentRequired: boolean;
  policyFileId: string | null;
  policySummary: PolicySummaryItem[] | null;
  description: string;
  documentFile: BladeFile[];
  documentFileId: string | null;
  principal: string;
  tenure: number;
  recoveryStartFrom: string;
  editLoanId?: number;
};

export type CreateLoanRequestProps = {
  isOpen: boolean;
  onClose: () => void;
  editLoan?: {
    id: number;
    principal: number;
    tenure: number;
    recoveryStartFrom: string;
    description?: string;
    loanCategoryId?: number;
    documentFileId?: string;
  };
};

export const INITIAL_LOAN_REQUEST_FORM_DATA: CreateLoanRequestFormData = {
  loanCategoryId: null,
  categoryName: '',
  isDocumentRequired: false,
  policyFileId: null,
  policySummary: null,
  description: '',
  documentFile: [],
  documentFileId: null,
  principal: '',
  tenure: 1,
  recoveryStartFrom: '',
};
